import ResidentsScreen from './ResidentsScreen'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'
import useHomeType from 'hooks/useHomeType'

export const ResidentScreenFeatureFlagWrapper = () => {
  const { hasRota } = useHomeType()

  const home = useSelector(
    (state: { global: { home: Home } }) => state?.global?.home
  )

  const hasLegacyMedications = home?.features?.carePlanMeds?.enabled
  return (
    <ResidentsScreen
      hasLegacyMedications={hasLegacyMedications}
      hasRota={hasRota}
      data-testid="residents-screen-wrapper"
    />
  )
}
